import { Component } from 'react';
import { withRouter } from 'react-router-dom';

class Analytics extends Component {
  componentDidMount() {
    const { location } = this.props;

    window.gtag('config', 'UA-90540608-7', {
      page_location: window.location.href,
      page_path: location.pathname,
    });

    this.props.history.listen((newLocation) => {
      window.gtag('config', 'UA-90540608-7', {
        page_location: window.location.href,
        page_path: newLocation.pathname,
      });
    });
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(Analytics);
